var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFloppyDiskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n        .disk-icon-st0{fill:currentColor;}\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "disk-icon-st0",
    d: "M12.0489 0.640625H2.2369C1.32929 0.640625 0.601562 1.37653 0.601562 2.27596V13.7233C0.601562 14.6227 1.32929 15.3586 2.2369 15.3586H13.6842C14.5837 15.3586 15.3196 14.6227 15.3196 13.7233V3.91129L12.0489 0.640625ZM13.6842 13.7233H2.2369V2.27596H11.3702L13.6842 4.58996V13.7233ZM7.96056 7.99963C6.60324 7.99963 5.50756 9.0953 5.50756 10.4526C5.50756 11.81 6.60324 12.9056 7.96056 12.9056C9.31789 12.9056 10.4136 11.81 10.4136 10.4526C10.4136 9.0953 9.31789 7.99963 7.96056 7.99963ZM3.05456 3.09363H10.4136V6.36429H3.05456V3.09363Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloppyDiskIcon);
export default __webpack_public_path__ + "static/media/floppy_disk-icon.145b1847138f8d283c6a218c4b5f5684.svg";
export { ForwardRef as ReactComponent };